import { thunk } from "redux-thunk";
import { createStore, applyMiddleware, Store } from "redux";
import { flowController } from "../redux/middleware/flowController";
import { navigationNextPage } from "../redux/actions";
import { rootReducer } from "../redux/reducers";
import { PageModel } from "../models/PageModel";
import { StoreState } from "../models/states/StoreState";

const MAX_PAGES = 20; // This is the maximum number of pages we should simulate.

const pageSelector = (state: StoreState) => state.interview.navigation?.currentPage;

function createSimulatedStore(initialState: StoreState) {
    return createStore(rootReducer, initialState, applyMiddleware(thunk, flowController));
}

function simulatePages(store: Store) {
    // Iterate until we get the same page twice.
    const pages = [];
    let lastPage: PageModel | undefined;
    let currentPage: PageModel | undefined;
    do {
        const previousPage = pageSelector(store.getState());
        (store as any).dispatch(navigationNextPage());
        if (currentPage) pages.push(currentPage);
        lastPage = currentPage;
        currentPage = pageSelector(store.getState());
        if (currentPage === previousPage) break;
        if (pages.length >= MAX_PAGES) return pages;
    } while (lastPage !== currentPage);
    return pages;
}

export async function startSimulationAsync(initialState: StoreState) {
    const store = createSimulatedStore(initialState);
    const pages = simulatePages(store as any);
    return pages;
}
